import { css } from "@emotion/core";
import { color, fontTypes } from "../../constants/commons";

export const dashboardStyles = (
  isMobile?: boolean,
  pageBackground?: string
) => css`
  font-family: ${fontTypes.bold};
  ${isMobile && `padding-top: 4em;`}
  background: ${pageBackground ? pageBackground : color.lightBlack};
  .extra-info {
    background: #ffffff10;
    border-radius: 0px;
    padding: 1em 1.25em;
    font-family: ${fontTypes.bodyFont};
    font-size: 14px;
    color: ${color.white};
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      margin-right: 13px;
    }
    .message-info {
      padding-top: 0.2em;
    }
  }
  .dashboard-content {
    background: ${color.lightBlack};
    display: flex;
    flex-direction: column;
    ${!isMobile && "align-items: center;"}
    color: ${color.white};
    padding: 6em 1em 3em 1em;
    h2 {
      color: ${color.white};
    }
    .dashboard-message {
      font-size: 1.12em;
    }
    .dashboard-steps {
      margin-top: 75px;
      ${!isMobile ? "margin-bottom: 75px; width: 80%;" : "width: 100%;"}
    }
    .ant-steps-item {
      .ant-steps-item-title {
        color: ${color.white};
        ${isMobile ? " font-size: 16px;" : "font-size: 20px;"}
      }
      .ant-steps-item-description {
        color: ${color.lightishGray};
        ${isMobile
          ? " font-size: 14px; margin-top:15px; margin-bottom:30px;"
          : "font-size: 16px;"}
        font-family: ${fontTypes.bodyFont};
      }
    }
    .ant-steps-item-wait {
      .ant-steps-item-tail::after {
        background-color: ${color.lighterGray};
      }
      .ant-steps-item-icon {
        background: ${color.black};
        border-color: ${color.lightishGray};
        .ant-steps-icon {
          color: ${color.lightishGray};
        }
      }
    }
    .ant-steps-item-process {
      .ant-steps-item-tail::after {
        background-color: ${color.lighterGray};
      }
      .ant-steps-item-icon {
        background: ${color.black};
        border-color: ${color.red};
        .ant-steps-icon {
          color: ${color.red};
        }
      }
    }
    .ant-steps-item-finish {
      .ant-steps-item-tail::after {
        background-color: ${color.red};
      }
      .ant-steps-item-icon {
        background: ${color.red};
        border-color: ${color.red};
        .ant-steps-icon {
          vertical-align: text-bottom;
          color: ${color.black};
        }
      }
    }
  }

  .dashboard-more-content {
    background: ${color.whitishGray};
    .working-easy {
      ${!isMobile &&
      `.responsive-widget{
        text-align: left;
        .responsive-widget-item {
          flex-direction: row;
          align-items: center;
          img {
            margin-bottom: 0;
            margin-right: 1.9em;
          }
        }
      }`}
    }
  }

  ${!isMobile &&
  `.ant-steps-item-container {
        width: 22vw;
        .ant-steps-item-tail {
            left: 8vw;
        }
        .ant-steps-item-icon {
            position: relative;
            left: 8vw;
        }
        .ant-steps-item-content {
            width: auto;
        }
    }
    .custom-button {
      padding: 0.88em 2em;
      width: 25%;
      margin-bottom: 1em;
    }
    `}
  ${isMobile &&
  `
      .custom-button {
        padding: 1em 2em;
        width: 100%;
        margin-bottom: 1em;
      }
    `}
`;

export const partnerSpeaksStyles = (isMobileView?: boolean) => css`
  ${!isMobileView &&
  `/* Extra small devices (portrait phones, less than 576px) */
    @media (max-width: 575.98px) {
      .header-container{
        padding: 0 1em;
      }
      .carousel-data-container{
        padding: 0 1em;
      }
    }
    /* Small devices (landscape phones, 576px and up) */
    @media (min-width: 576px) and (max-width: 767.98px) {
      .header-container{
        padding: 0 1em;
      }
      .carousel-data-container{
        padding: 0 1em;
      }
    }
    /* Medium devices (tablets, 768px and up) */
    @media (min-width: 768px) and (max-width: 991.98px) {
      .header-container{
        padding: 0 2.5em;
      }
      .carousel-data-container{
        padding: 0 2.5em;
      }
    }
    /* Large devices (desktops, 992px and up) */
    @media (min-width: 992px) and (max-width: 1199.98px) {
      .header-container{
        padding: 0 6em;
      }
      .carousel-data-container{
        padding: 0 6em;
      }
    }
    /* Extra large devices (large desktops, 1200px and up) */
    @media (min-width: 1200px) {
      .header-container{
        padding: 0 10em;
      }
      .carousel-data-container{
        padding: 0 10em;
      }
    }

    .card-container {
      max-width: none !important;
    }

    video {
      max-width: 28.75em !important;
      /* Medium devices (tablets, 768px and up) */
      @media (min-width: 768px) and (max-width: 991.98px) {
        max-width: 20em !important;
      }
    }`}
`;
